import type { ReactNode } from 'react'
import { clsx } from 'clsx'
import { removeUndefinedProps } from '../../../../shared/component-helper'
import SummaryListContext from './SummaryListContext'
import type { DlAllProps } from '../../../../elements/Dl'
import Dl from '../../../../elements/Dl'
import ValueProvider from '../Provider/ValueProvider'
import type { ValueProps } from '../../types'
import { useVerifyChildren } from './useVerifyChildren'
import withComponentMarkers from '../../../../shared/helpers/withComponentMarkers'

export type ValueSummaryListProps = Omit<
  DlAllProps,
  'label' | 'labelSrOnly' | 'children'
> & {
  children: ReactNode
  transformLabel?: ValueProps['transformLabel']
  inheritVisibility?: ValueProps['inheritVisibility']
  inheritLabel?: ValueProps['inheritLabel']
}

function SummaryList(props: ValueSummaryListProps) {
  const {
    className,
    children,
    layout = 'vertical',
    transformLabel,
    inheritVisibility,
    inheritLabel,
    ...rest
  } = props

  const valueProviderProps = removeUndefinedProps({
    transformLabel,
    inheritVisibility,
    inheritLabel,
  })

  const { verifyChild } = useVerifyChildren({
    children,
    message: 'Value.SummaryList accepts only Value.* components!',
    messageInfo: props,
    ignoreTypes: ['Visibility', 'ValueBlock', 'CompositionValue'],
  })

  return (
    <SummaryListContext value={{ layout, verifyChild }}>
      <Dl
        className={clsx('dnb-forms-summary-list', className)}
        layout={layout}
        {...rest}
      >
        <ValueProvider {...valueProviderProps}>{children}</ValueProvider>
      </Dl>
    </SummaryListContext>
  )
}

withComponentMarkers(SummaryList, {
  _supportsSpacingProps: true,
})

export default SummaryList
